const emailRegexp = /[a-z0-9][.']?(?:(?:[a-z0-9_-]+[.'])*[a-z0-9_-]+)*@(?:[a-z0-9]+(?:\.|-{1,2}))*[a-z0-9]+\.[a-z]{2,}/ig

export { emailRegexp }
